var Typeahead, ax, base, base1, getAutocompleteList, getRecentSearches, moveAutocomplete, ref, removeRecentSearch, removeRecentSearches, setRecentSearches,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

ref = require('../helper/m_typeahead_helper'), getAutocompleteList = ref.getAutocompleteList, getRecentSearches = ref.getRecentSearches, moveAutocomplete = ref.moveAutocomplete, removeRecentSearch = ref.removeRecentSearch, removeRecentSearches = ref.removeRecentSearches, setRecentSearches = ref.setRecentSearches;

ax = require('../helper/m_common').ax;

module.exports = Typeahead = (function() {
  function Typeahead(opts) {
    this.buildAutocompleteList = bind(this.buildAutocompleteList, this);
    this.removeTabIndex = bind(this.removeTabIndex, this);
    this.rerender = bind(this.rerender, this);
    this.success = bind(this.success, this);
    var ref1, ref2, ref3;
    this.env = opts.env, this.hasBetterUx = opts.enableBetterUx, this.hasGeolocation = opts.enableGeolocation, this.hasSearchCategories = opts.enableSearchCategories, this.endpoints = opts.endpoints, this.experiments = opts.experiments, this.$container = opts.resultList;
    this.query = '';
    this.ctx = 'search';
    this.$form = $('#search-bar, #ls-search-form');
    this.$inputs = this.$form.find('input');
    this.$search = this.$form.find('#search, #ls-search');
    this.$location = this.$form.find('#location, #ls-location');
    this.lat = typeof Groupon !== "undefined" && Groupon !== null ? (ref1 = Groupon.division) != null ? ref1.lat : void 0 : void 0;
    this.lng = typeof Groupon !== "undefined" && Groupon !== null ? (ref2 = Groupon.division) != null ? ref2.lng : void 0 : void 0;
    this.locale = document.head.getAttribute('data-locale');
    this.consumer_id = Cookie.get('snickerdoodle');
    this.result = [];
    this.hasRecentSearches = false;
    this.hasRecentLocations = false;
    if (opts.enableRecentSearches) {
      this.getRecentSearches();
    }
    if (opts.enableRecentLocations) {
      this.getRecentLocations();
    }
    if ((ref3 = Groupon.LS) != null ? ref3.hasTouch : void 0) {
      this.setBHViewport();
    }
    this.bind();
  }

  Typeahead.prototype.bind = function() {
    this.$container.on('click', '.tw-item .tw-clear', (function(_this) {
      return function(e) {
        var $item, ctx, value;
        e.preventDefault();
        e.stopImmediatePropagation();
        $item = $(e.currentTarget).siblings('.tw-link');
        if (!(value = $item.attr('data-value'))) {
          return;
        }
        ctx = _this.ctx;
        removeRecentSearch(value, ctx);
        _this.rerender(e, ctx);
      };
    })(this));
    this.$container.on('click', '.tw-heading .tw-clear', (function(_this) {
      return function(e) {
        var ctx;
        ctx = _this.ctx;
        removeRecentSearches(ctx);
        _this.rerender(e, ctx);
      };
    })(this));
  };


  /**
   * Fetch relevance API (deal / location)
   *
   * @param {String} query - Term to search
   */

  Typeahead.prototype.fetch = function(query) {
    var ell, lat, lng, ref1;
    if ($('.ls-error-dialog').length) {
      return;
    }
    if (this.env === 'desktop') {
      if (Groupon.LS.flags['useELLCoords'] && ((ell = Cookie.get('ell')) != null)) {
        ref1 = ell.split(','), lat = ref1[0], lng = ref1[1];
      } else {
        lat = this.lat;
        lng = this.lng;
      }
    }
    this.query = query;
    return $.ajax({
      url: this.endpoints[this.ctx],
      contentType: "application/json; charset=utf-8",
      dataType: "jsonp",
      type: 'get',
      data: {
        query: this.query,
        limit: 10,
        lat: this.lat,
        lng: this.lng,
        locale: this.locale,
        consumer_id: this.consumer_id
      },
      cache: false,
      success: this.success,
      error: (function(_this) {
        return function() {
          return _this.reset();
        };
      })(this)
    });
  };


  /**
   * Success handler for relevance API call.
   * Selects and updates response.
   *
   * @param {Object} res - Object containing API response for either deal or location
   */

  Typeahead.prototype.success = function(res) {
    var deals, locations, result;
    if ($('.ls-error-dialog').length) {
      return;
    }
    locations = res.locationsAutocompleteResults, deals = res.dealsAutocompleteResults;
    result = [];
    if (deals != null ? deals.length : void 0) {
      result = [
        {
          collection: deals,
          widget: 'autocomplete'
        }
      ];
    } else if (locations != null ? locations.length : void 0) {
      result = [
        {
          collection: locations,
          widget: 'autocomplete'
        }
      ];
    }
    if (this.hasGeolocation && locations) {
      result.unshift({
        collection: [],
        widget: 'geolocation'
      });
    }
    if (result.length) {
      this.result = _.deepClone(result);
    }
    this.buildView(this.result, this.query);
  };


  /**
   * Generate typeahead html and append to typeahead container
   *
   * @param {Array}  collections - Updated
   * @param {String} query
   */

  Typeahead.prototype.buildView = function(collections, query) {
    var $container, bh, bhw, index, list, prefix, ref1;
    this.reset();
    if (!collections.length) {
      return;
    }
    $container = this.$container;
    ref1 = getAutocompleteList(collections, query, {
      experiments: this.experiments
    }), list = ref1.list, index = ref1.index, bh = ref1.bh, prefix = ref1.prefix;
    if (list != null ? list.length : void 0) {
      list.unshift("<ul id='autocomplete-list' role='list' data-" + bh.type + "='" + bh.val + "'>");
      list.push('</ul>');
      switch (this.ctx) {
        case 'search':
          bhw = 'DealSearchBarAutoComplete';
          if (prefix) {
            this.$search.attr('aria-activedescendant', prefix + '0');
          }
          this.$search.removeAttr('aria-busy');
          break;
        case 'location':
          bhw = 'LocationSearchBarAutoComplete';
          if (prefix) {
            this.$location.attr('aria-activedescendant', prefix + '0');
          }
          this.$location.removeAttr('aria-busy');
      }
      $container.removeClass('typeahead-search typeahead-location').addClass('typeahead-' + this.ctx).html(list.join('')).attr('data-bhw', bhw).show();
      ax.show($container, this.removeTabIndex);
      if (this.env === 'desktop' && index > -1) {
        this.highlightMatch($container);
      }
    } else {
      ax.hide($container);
      $container.hide();
    }
  };

  Typeahead.prototype.rerender = function(e, ctx) {
    switch (ctx) {
      case 'search':
        this.getRecentSearches();
        break;
      case 'location':
        this.getRecentLocations();
    }
    if (e != null) {
      e.currentTarget.id = ctx;
    }
    this.buildAutocompleteList(e, ctx);
  };

  Typeahead.prototype.removeTabIndex = function() {
    return this.$container.removeAttr('tabindex');
  };


  /*
   * Clear typeahead list
   */

  Typeahead.prototype.reset = function() {
    this.$container.find('ul').empty();
    ax.hide(this.$container);
    this.$inputs.removeAttr('aria-activedescendant').attr('aria-busy', 'true');
  };

  Typeahead.prototype.hide = function() {
    this.reset();
    return this.$container.hide().attr('aria-hidden', 'true').empty().html('<ul id="autocomplete-list" role="list" aria-busy="true"></ul>');
  };


  /**
   * Method triggered by deal / location input events to decide
   * the type of typeahead and emit relevance ajax request
   *
   * @param {Object} e   - jQuery event
   * @param {String} ctx - Context: 'search' or 'location' input
   */

  Typeahead.prototype.buildAutocompleteList = function(e, ctx) {
    var id, query, ref1;
    if (e != null) {
      e.preventDefault();
    }
    this.ctx = ctx;
    ref1 = e.currentTarget, id = ref1.id, query = ref1.value;
    moveAutocomplete(this.$container, ctx, this.env);
    if (e.type === 'focusin' && id === 'ls-location') {
      query = '';
    } else {
      query = (query != null ? query.trim() : void 0) || '';
    }
    if (!query) {
      this.reset();
      switch (id) {
        case 'search':
        case 'ls-search':
          this.showDealWidget();
          break;
        case 'location':
        case 'ls-location':
          this.showLocationWidget();
      }
    } else {
      switch (e.type) {
        case 'input':
          if (query !== this.query) {
            this.fetch(query);
          }
          break;
        default:
          this.fetch(query);
      }
    }
  };

  Typeahead.prototype.getRecentSearches = function() {
    var ref1;
    this.recentKeywords = getRecentSearches('deal');
    return this.hasRecentSearches = ((ref1 = this.recentKeywords) != null ? ref1.length : void 0) > 0;
  };

  Typeahead.prototype.getRecentLocations = function() {
    var locations, ref1;
    locations = getRecentSearches('location');
    this.recentLocations = locations.filter(function(e) {
      return e.hasOwnProperty('division');
    });
    if (((ref1 = this.recentLocations) != null ? ref1.length : void 0) > 0) {
      if (this.recentLocations.length !== locations.length) {
        setRecentSearches(this.recentLocations, 'location');
      }
      if (typeof this.recentLocations[0] === 'object') {
        return this.hasRecentLocations = true;
      } else {
        return typeof localStorage !== "undefined" && localStorage !== null ? localStorage.removeItem('LS_recentLocations') : void 0;
      }
    }
  };

  Typeahead.prototype.highlightMatch = function($list) {
    var $matchedItem;
    $matchedItem = $list.find('.typeahead-match');
    return $list.on({
      mouseenter: function() {
        document.activeElement.blur();
        return $matchedItem.removeClass('typeahead-match-highlight');
      },
      mouseleave: function() {
        return $matchedItem.addClass('typeahead-match-highlight');
      }
    });
  };


  /*
   * Build configurable collections for deal typeahead when input is empty
   */

  Typeahead.prototype.showDealWidget = function() {
    var collections, hasRecentSearches, hasSearchCategories, keywords, ref1, ref2, ref3;
    hasRecentSearches = this.hasRecentSearches;
    hasSearchCategories = this.hasSearchCategories;
    if (!this.searchCategories) {
      this.searchCategories = ((ref1 = Groupon.LS.data) != null ? ref1.searchCategories : void 0) || [];
      this.hasSearchCategories = hasSearchCategories = ((ref2 = this.searchCategories) != null ? ref2.length : void 0) > 0;
    }
    if (hasRecentSearches || hasSearchCategories) {
      collections = [];
      if (hasRecentSearches) {
        keywords = (ref3 = this.recentKeywords) != null ? ref3.slice(0) : void 0;
        collections.push.apply(collections, [
          {
            collection: keywords,
            widget: 'recentSearches'
          }
        ]);
      }
      if (hasSearchCategories) {
        collections.push.apply(collections, [
          {
            collection: this.searchCategories.slice(0),
            widget: 'searchCategories'
          }
        ]);
      }
      if (collections != null ? collections.length : void 0) {
        this.buildView(collections);
      }
    }
  };


  /*
   * Build configurable collections for location typeahead when input is empty
   */

  Typeahead.prototype.showLocationWidget = function() {
    var collections, hasBetterUx, hasGeolocation, hasRecentLocations, keywords, ref1;
    hasGeolocation = this.hasGeolocation;
    hasRecentLocations = this.hasRecentLocations;
    hasBetterUx = this.hasBetterUx;
    if (hasGeolocation || hasRecentLocations || hasBetterUx) {
      collections = [];
      if (hasGeolocation) {
        collections.push.apply(collections, [
          {
            collection: [],
            widget: 'geolocation'
          }
        ]);
      }
      if (hasBetterUx) {
        collections.push.apply(collections, [
          {
            collection: [],
            widget: 'helperMessage'
          }
        ]);
      }
      if (hasRecentLocations) {
        keywords = (ref1 = this.recentLocations) != null ? ref1.slice(0, 5) : void 0;
        collections.push.apply(collections, [
          {
            collection: keywords,
            widget: 'recentLocations'
          }
        ]);
      }
      if (collections != null ? collections.length : void 0) {
        this.buildView(collections);
      }
    }
  };


  /*
   * Prevent bloodhound impression tracking on typeahead due to performance reasons
   */

  Typeahead.prototype.setBHViewport = function(state) {
    if (state == null) {
      state = 'ignore';
    }
    this.$container.attr('data-bh-viewport', state);
  };

  return Typeahead;

})();

if ((base = window.Groupon.Modules).SearchBar == null) {
  base.SearchBar = {};
}

if ((base1 = window.Groupon.Modules.SearchBar).View == null) {
  base1.View = {};
}

_.extend(window.Groupon.Modules.SearchBar.View, {
  Typeahead: Typeahead
});

